
import { Component, Prop, Vue } from 'vue-property-decorator'
import Documents from '@/components/Profile/VesselDocuments.vue'
import { Vessel } from '@/models/Vessel'
import User from '@/models/User'
import { namespace } from 'vuex-class'
import { Document } from '@/models/Document'
import FileTag from '@/enums/FileTag'

const VesselDetails = namespace('vesselDetails')
const Auth = namespace('auth')

@Component({
	components: {
		Documents
	}
})
export default class VesselDocuments extends Vue {
    @Prop({ required: false, default: null })
    vesselId!: string | null

    @Prop({ required: false, default: false })
    isModal!: boolean

	@VesselDetails.Mutation('setVessel')
	setVesselState

	@Auth.Getter('ownVessel')
	ownVessel!: Vessel | null

	get isOwnVessel() {
		if (!this.vessel || !this.ownVessel) return false
		return this.vessel?.getApiId() === this.ownVessel?.getApiId()
	}

	get shouldShowAlert() {
		return this.isOwnVessel && !this.ownVessel?.getVesselAttribute('measurement_certificate')?.value
	}

	vessel: Vessel | null = null

    async created() {
        this.setVesselState(null)

        if (this.vesselId) {
            this.vessel = await Vessel.fetchLazy(this.vesselId)
        } else {
            const user = await User.fetchMeLazy()
            const vessels = user.getVessels() as Array<Vessel>
            this.vessel = vessels[0]
        }

        this.setVesselState(this.vessel)
    }

	async fileUploaded(uploadedFile: Document) {
		if (this.isOwnVessel && uploadedFile.tag === FileTag.MEASUREMENT_CERTIFICATE) {
			await User.sync(true)
		}
	}
}
